// extracted by mini-css-extract-plugin
export default {"wrapper":"MainLayout_wrapper__GlRSQ","mainBox":"MainLayout_mainBox__6aVL3","mainContainer":"MainLayout_mainContainer__JwBd-"};